import type { UserStatus } from '@/types/organization.types';
import type { UserEntity, UserUpsertDTO, UserId, InvitationResponse, CreatedUserResponse } from '@/types/users.types';

export abstract class UsersService {
  abstract createUser(data: UserUpsertDTO): Promise<CreatedUserResponse>;
  abstract updateUser(id: UserId, data: UserUpsertDTO): Promise<UserEntity>;
  abstract toggleActiveUser(id: string, status: UserStatus): Promise<void>;
  abstract forceLogoutUser(id: string): Promise<void>;
  abstract forceLoginResetUser(id: string): Promise<void>;
  abstract deleteUser(id: string): Promise<void>;
  abstract getInvitationLink(id: string): Promise<InvitationResponse>;

  /**
   * Polls the backend until an invitation link is available for the user,
   * or rejects on timeout/abort.
   */
  abstract waitForInvitationLink(
    userId: string,
    options?: { intervalMs?: number; timeoutMs?: number; signal?: AbortSignal }
  ): Promise<InvitationResponse>;
}
